import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import {Contact} from "../../translator/outbound-translator";

interface Display {display: string, type: string}
@Component({
  selector: 'app-contact-bubble',
  templateUrl: './receive-contact.component.html',
  styleUrls: ['./receive-contact.component.scss']
})
export class ReceiveContactComponent implements OnInit {
  @Input() content;
  @Input() messageSource: Boolean;
  contact: Contact;
  displayName: string;
  showViewContact = false;
  address: Display[];
  emailAddress: Display[];
  phoneNumbers: Display[];
  urlAddresses: Display[];
  organisationName: string;
  birthdayDisplay: string;
  constructor() { }

  ngOnInit(): void {
    this.contact = this.content.contacts;
    this.displayName = this.contact.name.formattedName;
    this.extractContacts();
  }

  viewContact() {
    this.showViewContact = !this.showViewContact;
  }

  extractContacts() {
    this.getAddress();
    this.getEmailAddress();
    this.getPhoneNumbers();
    this.getUrls();
    this.organisationName = this.contact?.org?.company;
    this.birthdayDisplay = this.contact?.birthday;
  }
  getContact(contact: []): any[] {
    if (contact.length > 0) {
      return contact;
    }
    return [];
  }

  getAddress() {
    const addr_display = (addr): Display => {
      if (addr !== undefined) {
        const address = addr;
         return  {
          display: address.street + ' ' + address.city + ' ' + address.state + ' ' + address.country +  ' ' + address.zip,
          type: address.type
        }
      }
    }
    this.address = this.getContact(this.contact.addresses).map(addr_display);
  }

  getEmailAddress() {
    const email_display = (emails): Display => {
      if (emails !== undefined) {
        return  {
          display: emails.email,
          type: emails.type
        }
      }
    }
    this.emailAddress = this.getContact(this.contact.emails).map(email_display);
  }
  getPhoneNumbers() {
    const  phone_display = (phone): Display => {
      if (phone !== undefined) {
        return {
          display: phone.phone,
          type: phone.type
        }
      }
    }
    this.phoneNumbers = this.getContact(this.contact.phones).map(phone_display);
  }

  getUrls() {
    const url_display = (url): Display => {
      if (url !== undefined) {
        return {
          display: url.url,
          type: url.type
        }
      }
    }
    this.urlAddresses = this.getContact(this.contact.urls).map(url_display);
  }

}
